import * as types from './ActionTypes';

export const state = {
	status: false,
	curRow: {},
	luck: false,
	listDraw: false,
};
export const mutations = {
	[types.SET_VOTE_STATUS](state, status) {
		state.status = status;
	},
	[types.SET_VOTE_CURROW](state, row) {
		state.curRow = row;
		if (Object.prototype.hasOwnProperty.call(row, 'id')) {
			state.status = true;
		}
	},
	[types.SET_VOTE_LUCK](state, luck) {
		state.luck = luck;
	},
	[types.SET_LIST_LUCK](state, luck) {
		state.listDraw = luck;
	},
};
